import { useState } from 'react';
import { Outlet } from 'react-router';
import { TopBar } from './TopBar';
import { SimulationBanner } from './SimulationBanner';
import { Sidebar } from './Sidebar';
import { Breadcrumb } from './Breadcrumb';
import { useIsDesktop } from '@/hooks/useMediaQuery';
import { AnalyticsTracker } from '@/features/analytics/AnalyticsTracker';

export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isDesktop = useIsDesktop();

  return (
    <div className="flex min-h-screen flex-col" data-testid="app-layout">
      <AnalyticsTracker />
      <a href="#main-content" className="skip-to-content">
        Skip to content
      </a>

      <TopBar
        onToggleSidebar={() => setSidebarOpen((prev) => !prev)}
        showMenuButton={!isDesktop}
      />
      <SimulationBanner />

      <div className="flex flex-1">
        <Sidebar
          isOpen={isDesktop || sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />

        <main
          id="main-content"
          data-testid="main-content"
          className="min-w-0 flex-1 px-7 py-6"
          style={{ backgroundColor: 'var(--app-bg)' }}
        >
          <Breadcrumb />
          <Outlet />
        </main>
      </div>
    </div>
  );
}
